import { type Routes } from '@angular/router';

/**
 * Dev/test sandbox routes under authenticated shell.
 * Production build replaces this file with `shell-dev.routes.prod.ts` (empty array) so lazy chunks are not emitted.
 */
export const SHELL_DEV_ROUTES: Routes = [
  {
    path: 'test-ui',
    loadChildren: () => import('./features/test-ui/test-ui.routes').then((m) => m.TEST_UI_ROUTES),
  },
  {
    path: 'demo-form',
    loadChildren: () =>
      import('./features/demo-form/demo-form.routes').then((m) => m.DEMO_FORM_ROUTES),
  },
  {
    path: 'state-baseline',
    loadChildren: () =>
      import('./features/state-baseline/state-baseline.routes').then(
        (m) => m.STATE_BASELINE_ROUTES,
      ),
  },
  {
    path: 'lifecycle-baseline',
    loadChildren: () =>
      import('./features/lifecycle-baseline/lifecycle-baseline.routes').then(
        (m) => m.LIFECYCLE_BASELINE_ROUTES,
      ),
  },
];
